<template>
    <div class="meta-nav">
        <ul>
            <li>
                <router-link to="/settings/attributes">
                    Attributes
                </router-link>
            </li>
            <li>
                <router-link to="/settings/queue">
                    Pending Events
                </router-link>
            </li>
            <li>
                <a href="javascript:;" @click="app.showActivationModal">
                    <template v-if="app.subscription">
                        Activation Code
                    </template>
                    <template v-else>
                        🔑 &nbsp; Activate
                    </template>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: ['app']
};
</script>
